<template>

  <Loader v-if="loader" />

  <prime-accordion class="box-operation-detail">
    <prime-accordion-tab>
      <template #header>
        <i class="pi pi-plus-circle"> </i>
        <span class="pl-1">Operazioni</span>
      </template>  
      
    </prime-accordion-tab>
  </prime-accordion>


  <div class="grid mb-4" v-if="data.item.info && data.item.info.id">
    <div class="col-12">
      <div  class="card mb-0">

        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-medium mb-1 title-detail">TOTALE FATTURA</span>
            <div class="flex align-items-center">
              <div class="text-900 font-medium text-xl mr-5" v-if="!infoIsInEdit">
                <div class="importo">  {{ currencyFormatter.format(data.item.info.totale_fattura) }}</div>
              </div>
              <div v-else div class="mr-5">
                <prime-input-number v-model="data.item.info.totale_fattura" :disabled="!infoIsInEdit" inputClass="importo" inputId="currency-italy" mode="currency" currency="EUR" locale="it-IT" />
              </div>
              <div class="flex justify-content-end">
                <div v-if="!infoIsInEdit">
                  <prime-button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="onEditInfo"/>
                </div>
  
                <div v-if="infoIsInEdit">
                  <prime-button icon="pi pi-times" class="p-button-rounded p-button-danger mr-2" @click="onAbortInfoEdit"/>
                  <prime-button icon="pi pi-check" class="p-button-rounded p-button-success mr-2" @click="onUpdateInfo"/>
                </div>
              </div>
            </div>
          </div>
          <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
            <i class="pi pi-euro text-blue-500 text-xl"></i>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-6">
              <p class="block text-500 font-medium mt-4 title-detail"> NUMERO FATTURA</p>
            <b style="font-size: 24px">{{data.item.info.numero}}</b>
          </div>
          <div class="col-12 md:col-6">
            <p class="block text-500 font-medium mt-4 title-detail"> FORNITORE</p>
            <b style="font-size: 24px">{{data.item.fornitore}}</b>
          </div>
        </div>
        <hr>
        <div class="grid mt-3">
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail"> DATA REGISTRAZIONE</p>
            <b>{{formatDate(data.item.info.data_registrazione)}}</b>
          </div>
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">DATA SCADENZA</p>
            <b>{{formatDate(data.item.info.data_scadenza)}}</b>
          </div>  
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">PROTOCOLLO</p>
            <b>{{data.item.info.protocollo}}</b>
          </div>
          <div class="col-6">
            <p class="block text-500 font-medium mb-1 title-detail">REVERSE</p>
            <b v-if="data.item.info.reverse">SI</b>
            <b v-else>NO</b>
          </div>
          
        </div>

        <div class="flex  justify-content-end mt-4">
          <div class="flex flex-column">
            <Button class="w-12rem" icon="pi pi-file-pdf" iconPos="right" @click="getInvoiceFromAgyo" label="Visualizza fattura" :disabled="!data.item.info.id_sdi" /> 
            <div class="text-xs uppercase p-1 p-error">
              <small v-if="!data.item.info.id_sdi">Id Sdi non presente</small>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  <div v-else class="card">
    <Skeleton class="mb-2"></Skeleton>
    <Skeleton width="100%" class="mb-2"></Skeleton>
    <Skeleton width="5rem" class="mb-2"></Skeleton>
    <Skeleton height="2rem" class="mb-2"></Skeleton>
    <Skeleton width="10rem" height="4rem"></Skeleton>
  </div>
   


  <prime-accordion :multiple="true" >

    <prime-accordion-tab header="Pagamenti">
      <prime-data-table :value="data.item.pagamenti" responsiveLayout="scroll">
        <prime-column field="data_contabile" header="Data Contabile">
          <template #body="{data}">
            {{ formatDate(data.data_contabile)}}
          </template>
        </prime-column>
        <prime-column field="type_pay_mode_name" header="Banca"></prime-column>
        <prime-column field="type_pay_name" header="Metodo"></prime-column>
        <prime-column field="value" header="Importo" :sortable="true" >
          <template #body="{data}">
            {{ currencyFormatter.format( (data.value !== null)? data.value: 0 )}}
          </template>
        </prime-column>
        <prime-column field="note" header="Note"></prime-column>
        <prime-column header="Azione">
            <template #body="{data}">
              <div v-if="canDissociareOEliminare(data)" class="flex align-items-center flex-wrap gap-2">
                <prime-button
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  class="p-button-rounded"
                  label="Vai alla dissociazione"
                  @click="dissociate({...data})"
                />
                <prime-button
                  icon="pi pi-trash"
                  iconPos="right"
                  class="ml-4 p-button-rounded p-button-danger"
                  label="Elimina"
                  @click="askDeletePagamento({...data})"
                />
              </div>
              <div v-else-if="data.cod_estrattoconto && data.cod_type_pay != 9">
                In Contabilità
              </div>
          </template>
        </prime-column>

      </prime-data-table>
    </prime-accordion-tab>
    
    <prime-accordion-tab header="Contabilità">
      <prime-data-table :value="data.item.contabilita" responsiveLayout="scroll">
        <prime-column field="totale" header="Importo">
          <template #body="{data}">
            {{ currencyFormatter.format( (data.totale !== null)? data.totale: 0 )}}
          </template>
        </prime-column>
        <prime-column field="aliquota" header="Aliquota"></prime-column>
        <prime-column field="art" header="Esenzione"></prime-column>
        <prime-column field="iva" header="Imposta">
          <template #body="{data}">
            {{ currencyFormatter.format( (data.iva !== null)? data.iva: 0 )}}
          </template>
        </prime-column>
        <prime-column field="totale_ivato" header="Totale">
          <template #body="{data}">
            {{ currencyFormatter.format( (data.totale_ivato !== null)? data.totale_ivato: 0 )}}
          </template>
        </prime-column>
        <prime-column field="tipologia" header="Tipologia"></prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="Info Fatture">
      <div v-if="infoFatture">
        <div v-if="infoFatture.fatture_grezze_cei_ee?.data?.length > 0">
          <h3>Info Fatture</h3>
          <prime-data-table 
            :value="infoFatture.fatture_grezze_cei_ee.data"
            :lazy="true"
            :paginator="true"
            :rows="10"
            :totalRecords="infoFatture.fatture_grezze_cei_ee.pagination.total"
            :loading="loading"
            @page="onPageCeiEE($event)"
            responsiveLayout="scroll">
            <prime-column field="numerofattura" header="Numero Fattura" :sortable="true"></prime-column>
            <prime-column field="datafattura" header="Data Fattura" :sortable="true"></prime-column>
            <prime-column field="quantita" header="Qta" :sortable="true"></prime-column>
            <prime-column field="totaleimponibile" header="Tot.Imponibile" :sortable="true"></prime-column>
            <prime-column field="potenzaimpegnata" header="Pot. Impegnata" :sortable="true"></prime-column>
            <prime-column field="potenzadisponibile" header="Pot. Disponibile" :sortable="true"></prime-column>
            <prime-column field="letturaattualepod" header="Lettura Attuale POD" :sortable="true"></prime-column>
          </prime-data-table>
        </div>

        <div v-if="infoFatture.fatture_grezze_cei_gas?.data?.length > 0" class="mt-4">
          <h3>Info Fatture</h3>
          <prime-data-table 
            :value="infoFatture.fatture_grezze_cei_gas.data"
            :lazy="true"
            :paginator="true"
            :rows="10"
            :totalRecords="infoFatture.fatture_grezze_cei_gas.pagination.total"
            :loading="loading"
            @page="onPageGas($event)"
            responsiveLayout="scroll">
            <prime-column field="numerofattura" header="Numero Fattura" :sortable="true"></prime-column>
            <prime-column field="datafattura" header="Data Fattura" :sortable="true"></prime-column>
            <prime-column field="quantita" header="Qta" :sortable="true"></prime-column>
            <prime-column field="totaleimponibile" header="Tot.Imponibile" :sortable="true"></prime-column>
            <prime-column field="potenzaimpegnata" header="Pot. Impegnata" :sortable="true"></prime-column>
            <prime-column field="potenzadisponibile" header="Pot. Disponibile" :sortable="true"></prime-column>
            <prime-column field="letturaattualecorrettore" header="Lettura Attuale Correttore" :sortable="true"></prime-column>
          </prime-data-table>
        </div>

        <div v-if="infoFatture.fatture_grezze_edistribuzione?.data?.length > 0" class="mt-4">
          <h3>Info Fatture</h3>
          <prime-data-table 
            :value="infoFatture.fatture_grezze_edistribuzione.data"
            :lazy="true"
            :paginator="true"
            :rows="10"
            :totalRecords="infoFatture.fatture_grezze_edistribuzione.pagination.total"
            :loading="loading"
            @page="onPageEdist($event)"
            responsiveLayout="scroll">
            <prime-column field="odn" header="Numero Fattura"></prime-column>
            <prime-column field="pfra" header="Potenza disponibile" :sortable="true"></prime-column>
            <prime-column field="tf" header="Prezzo Unitario" :sortable="true"></prime-column>
            <prime-column field="dat" header="Data documento" :sortable="true"></prime-column>
          </prime-data-table>
        </div>
      </div>
    </prime-accordion-tab>
    
  </prime-accordion>

  <prime-dialog
    v-model:visible="deletePagamentoDialog"
    :style="{ width: '450px' }"
    header="Conferma eliminazione"
    :modal="true"
  >
    <div class="confirmation-content flex align-items-center">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem; color: var(--red-500)" />
      <span>Eliminare questa riga di pagamento? L'operazione non può essere annullata.</span>
    </div>
    <template #footer>
      <prime-button
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        @click="deletePagamentoDialog = false"
      />
      <prime-button
        label="Elimina riga"
        icon="pi pi-trash"
        class="p-button-danger"
        @click="confirmDeletePagamento"
      />
    </template>
  </prime-dialog>

</template>


<script>
import FattureService from '@/services/ask-management/fatture-acquisto-service'
import UtilityAgyoService from '@/services/ask-management/utility-agyo-service'

// import router from '@/router';

import Loader from '@/components/Loader.vue'
import PrimeAccordion from 'primevue/accordion'
import PrimeAccordionTab from 'primevue/accordiontab'
import PrimeButton from'primevue/button'
import PrimeDataTable from 'primevue/datatable'
import PrimeColumn from 'primevue/column'
import PrimeInputNumber from 'primevue/inputnumber'
import PrimeDialog from 'primevue/dialog'

import moment from 'moment'

export default {
  name: 'ViewAskFattureAcquistoDetail',
  components: {
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeButton,
    PrimeDataTable,
    PrimeColumn,
    PrimeInputNumber,
    PrimeDialog,
    Loader
  },

  data() {
    return {
      moment,

      loader: false,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      route: {
        params: null
      },
      infoIsInEdit: false,
      oldInfo: null,

      data: {
        item: {}
      },
      totale_fattura: 0,
      infoFatture: null,
      loading: false,
      deletePagamentoDialog: false,
      selectedPagamento: null,
      deletingPagamento: false,

    }
  },

  created(){
    this.route.params = this.$route.params
    // console.log(this.route.params)
    this.formatDate = this.$formatDate
    this.fattureService = new FattureService(this.$http, this.$eventBus)
    this.agyoService = new UtilityAgyoService(this.$http, this.$eventBus)
    this.getDettaglioFattura(this.route.params.id)
  },

  methods:{

    getDettaglioFattura(id){
      this.loader = true
      this.fattureService.getDettaglioFattura(id).then((res) => {
        this.data.item = res.item
        this.totale_fattura = this.data.item.info.totale_fattura
        document.title = 'numero' in this.data.item.info ? document.title +" - "+  this.data.item.info.numero : document.title
        this.getInfoFattureGrezze()
      }).finally(() => {
        this.loader = false
      })
    },
    getInvoiceFromAgyo () {
      let id_sdi = this.data.item.info.id_sdi
      if (id_sdi) {
        this.loader = true
        this.agyoService.getInvoiceFromAgyo(id_sdi).then((res) => {
          const blob = new Blob([res.data], {type: 'application/pdf'}); 
          var blobURL = URL.createObjectURL(blob);
          window.open(blobURL);
        }).finally(() => {
          this.loader = false
        })
      } else {
        alert('nessun id_sdi')
      }
       
    },
    canDissociareOEliminare(row) {
      if (!row?.cod_estrattoconto) {
        return false
      }
      if (Number(row.cod_type_pay) === 9) {
        return Number(this.data.item?.info?.totale_fattura) < 0
      }
      return Number(row.passedToTeamSystem) === 0
    },
    dissociate (data) {
      window.open(`/estratti-conto/detail/regularized/${data.cod_estrattoconto}`, '_blank')
    },
    askDeletePagamento(row) {
      if (this.deletingPagamento || !this.canDissociareOEliminare(row) || !row?.id) {
        return
      }
      this.selectedPagamento = row
      this.deletePagamentoDialog = true
    },
    async confirmDeletePagamento() {
      const pagamento = this.selectedPagamento
      const idFattura = this.data.item?.info?.id
      this.deletePagamentoDialog = false
      if (this.deletingPagamento || !pagamento?.id || !idFattura) {
        return
      }

      this.deletingPagamento = true
      this.loader = true
      try {
        const res = await this.fattureService.deletePagamento(idFattura, pagamento.id)
        if (res.success) {
          if (res.item?.info && Array.isArray(res.item.pagamenti)) {
            this.data.item = res.item
            this.totale_fattura = this.data.item.info.totale_fattura ?? this.totale_fattura
          } else {
            await this.getDettaglioFattura(idFattura)
          }
          this.$toast.add({
            severity: 'success',
            summary: 'Pagamento eliminato',
            detail: 'La riga di pagamento è stata eliminata',
            life: 3000,
          })
        } else if (res.status === 422 || res.status === 404) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Operazione non consentita',
            detail: res.message || 'Questa riga non può essere eliminata',
            life: 3000,
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: res.message || 'Impossibile eliminare la riga di pagamento',
            life: 3000,
          })
        }
      } catch (error) {
        console.error('Errore durante l\'eliminazione del pagamento:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile eliminare la riga di pagamento',
          life: 3000,
        })
      } finally {
        this.selectedPagamento = null
        this.deletingPagamento = false
        this.loader = false
      }
    },
    onEditInfo(){
      this.oldInfo = JSON.stringify(this.data.item.info)

      this.infoIsInEdit = !this.infoIsInEdit
    },

    onAbortInfoEdit(){
      this.data.item.info = JSON.parse(this.oldInfo)

      this.oldInfo = null
      this.infoIsInEdit = !this.infoIsInEdit
    },
    onUpdateInfo(){
      const allowed = [
        'totale_fattura'
      ]
      
      const info = Object.keys(this.data.item.info)
      .filter(key => allowed.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: this.data.item.info[key]
        };
      }, {})

      // if(info.totale_fattura < 0){
      //   info.totale_fattura = null
      // }      

      if( this.oldInfo != JSON.stringify(this.data.item.info) ) {
        this.fattureService.updateInfo(this.data.item.info.id, info).then((res) => {
          // console.log('UPDATED', res)
          if(res.success){
            delete res.item.id

            this.data.item = res.item
          }
        })
      }

      this.oldInfo = null
      this.infoIsInEdit = !this.infoIsInEdit
    },
    async getInfoFattureGrezze() {
      if (this.data.item.info && this.data.item.info.numero) {
        this.loader = true
        try {
          const response = await this.fattureService.getInfoFattureGrezze(this.data.item.info.numero)
          this.infoFatture = response
        } catch (error) {
          console.error('Errore nel recupero delle info fatture:', error)
        } finally {
          this.loader = false
        }
      }
    },
    async onPageCeiEE(event) {
      this.loading = true
      try {
        const response = await this.fattureService.getInfoFattureGrezze(
          this.data.item.info.numero,
          event.page + 1,
          event.rows
        )
        this.infoFatture.fatture_grezze_cei_ee = response.fatture_grezze_cei_ee
      } finally {
        this.loading = false
      }
    },

    async onPageGas(event) {
      this.loading = true
      try {
        const response = await this.fattureService.getInfoFattureGrezze(
          this.data.item.info.numero,
          event.page + 1,
          event.rows
        )
        this.infoFatture.fatture_grezze_cei_gas = response.fatture_grezze_cei_gas
      } finally {
        this.loading = false
      }
    },

    async onPageEdist(event) {
      this.loading = true
      try {
        const response = await this.fattureService.getInfoFattureGrezze(
          this.data.item.info.numero,
          event.page + 1,
          event.rows
        )
        this.infoFatture.fatture_grezze_edistribuzione = response.fatture_grezze_edistribuzione
      } finally {
        this.loading = false
      }
    },

  }

}
</script>


<style>
.importo {
  font-size: 3.5rem !important;
  color: var(--blue-500) !important;
}

.title-detail {
  font-size: 10px;
  letter-spacing: 2px;
}

</style>

